import { type MotivoFallo, MENSAJES_DE_FALLO } from '../passkeys/api/passkeyLoginService';
import { Fingerprint } from './LoginBits';

type Props = {
  email: string;
  /** Pidiendo el desafío por adelantado: el botón todavía no puede usarse. */
  preparando: boolean;
  /** La ceremonia biométrica o la verificación están en curso. */
  ingresando: boolean;
  fallo: MotivoFallo | null;
  onEntrar: () => void;
  onUsarContrasena: () => void;
  onNoSoyYo: () => void;
};

/**
 * El bloque principal del login cuando este navegador ya activó la entrada
 * rápida: quién es, un botón grande de biometría y, a la vista, el camino por
 * contraseña. Reemplaza al formulario de email y contraseña (LoginCard).
 */
export function QuickLoginPanel({
  email,
  preparando,
  ingresando,
  fallo,
  onEntrar,
  onUsarContrasena,
  onNoSoyYo,
}: Props) {
  const ocupado = preparando || ingresando;
  const mensaje = fallo ? MENSAJES_DE_FALLO[fallo] : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 10,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 10,
              fontWeight: 600,
              color: 'rgba(255,255,255,0.55)',
              textTransform: 'uppercase',
              letterSpacing: '0.14em',
              marginBottom: 4,
            }}
          >
            Entrás como
          </div>
          <div
            title={email}
            style={{
              color: '#f6fbff',
              fontSize: 14,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {email}
          </div>
        </div>
        <button
          type="button"
          className="dd-link-btn"
          onClick={onNoSoyYo}
          disabled={ingresando}
        >
          No soy yo
        </button>
      </div>

      <button
        type="button"
        className="dd-enter-btn"
        onClick={onEntrar}
        disabled={ocupado}
        aria-busy={ocupado}
        autoFocus
        style={{ marginTop: 0 }}
      >
        {ocupado ? (
          <>
            <span className="dd-spinner" aria-hidden="true" />
            <span>{ingresando ? 'Verificando…' : 'Preparando…'}</span>
          </>
        ) : (
          <>
            <span style={{ display: 'inline-flex' }} aria-hidden="true">
              <Fingerprint color="#062029" size={18} />
            </span>
            <span>Entrar con huella / Face ID</span>
          </>
        )}
      </button>

      {mensaje && (
        <div
          role="alert"
          style={{
            padding: '10px 12px',
            border: '1px solid rgba(255, 142, 142, 0.35)',
            background: 'rgba(255, 142, 142, 0.07)',
            borderRadius: 5,
          }}
        >
          <div style={{ fontSize: 12.5, fontWeight: 600, color: '#ffb4b4', marginBottom: 2 }}>
            {mensaje.titulo}
          </div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.62)', lineHeight: 1.5 }}>
            {mensaje.detalle}
          </div>
        </div>
      )}

      <button
        type="button"
        className="dd-link-btn"
        onClick={onUsarContrasena}
        disabled={ingresando}
        style={{ alignSelf: 'center' }}
      >
        Entrar con contraseña
      </button>
    </div>
  );
}
